/*
 * Calendar Event Info Panel Component
 * Displays read-only view of event information.
 * 
 * Angular module: trackerbase-app.views.tracking-calendar-view.calendar-event-info-panel
 * Directive: tbCalendarEventInfoPanel (tb-calendar-event-info-panel)
 */
import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import CalendarEventInfoPanelController from "./CalendarEventInfoPanelController";

const CalendarEventInfoPanelComponent = {
    name: "tbCalendarEventInfoPanel",
    config: {
        template: CalendarEventInfoPanelController.template,
        bindings: {
            additionalPanelClasses: "@tbAdditionalPanelClasses",
            calendarEventId: "=tbCalendarEventId",
            displayEventInfoPanel: "=tbDisplayEventInfoPanel",
            navigateToEventEditorFn: "&tbNavigateToEventEditorFn"
        },
        controller: CalendarEventInfoPanelController,
        controllerAs: CalendarEventInfoPanelController.controllerAs,
        transclude: true
    }
};

const calendarEventInfoPanelComponentDependencies = DependencyListBuilder([
    CalendarEventInfoPanelController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view.calendar-event-info-panel",
        calendarEventInfoPanelComponentDependencies
    )
    .component(CalendarEventInfoPanelComponent.name, CalendarEventInfoPanelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/CalendarEventInfoPanel.js
// module id = e4SK
// module chunks = 1